var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Center, Icon } from "@chakra-ui/react";
import { observer } from "mobx-react";
import React from "react";
import { BsMicFill } from '@react-icons/all-files/bs/BsMicFill';
import { BsMicMuteFill } from '@react-icons/all-files/bs/BsMicMuteFill';
import { FcEndCall } from "@react-icons/all-files/fc/FcEndCall";
import { FcNoVideo } from '@react-icons/all-files/fc/FcNoVideo';
import { FcVideoCall } from '@react-icons/all-files/fc/FcVideoCall';
import { FcSwitchCamera } from '@react-icons/all-files/fc/FcSwitchCamera';
import { MdScreenShare } from '@react-icons/all-files/md/MdScreenShare';
import { MdStopScreenShare } from '@react-icons/all-files/md/MdStopScreenShare';
import { GoScreenFull } from '@react-icons/all-files/go/GoScreenFull';
import { StoreContext } from '@/app/uistore/Rootstore';
import { testIsMobile } from '@@/Util';
let MediaControl = class MediaControl extends React.Component {
    toggleMyAudio() {
        const rstore = this.context;
        rstore.mediastore.toggleMyAudio();
    }
    toggleMyVideo() {
        var _a, _b, _c;
        const rstore = this.context;
        if (rstore.mediastore.mymedia !== undefined && ((_a = rstore.mediastore.mymedia) === null || _a === void 0 ? void 0 : _a.mediastream) !== undefined &&
            ((_c = (_b = rstore.mediastore.mymedia) === null || _b === void 0 ? void 0 : _b.mediastream) === null || _c === void 0 ? void 0 : _c.getVideoTracks().length) > 0) {
            rstore.mediastore.toggleMyVideo();
        }
    }
    endCall() {
        const rstore = this.context;
        rstore.mediastore.disconnect();
    }
    shareScreen() {
        const rstore = this.context;
        rstore.mediastore.toogleScreenShare();
    }
    fullScreen() {
        const rstore = this.context;
        rstore.mediastore.fullScreenFocued();
    }
    switchMediaDevice() {
        const rstore = this.context;
        rstore.mediastore.setSwitchMode(true);
        rstore.mediastore.getDevices();
    }
    render() {
        var _a, _b;
        const rstore = this.context;
        if (!rstore.mediastore.mymediaactive) {
            return React.createElement(Center, null);
        }
        //@ts-ignore
        const devicesavaliab = (navigator.mediaDevices).getDisplayMedia;
        return React.createElement(Center, null,
            React.createElement(Icon, { color: 'lightgray', w: '30px', h: '30px', _hover: { cursor: 'pointer' }, onClick: () => this.toggleMyAudio(), as: ((_a = rstore.mediastore.mymedia) === null || _a === void 0 ? void 0 : _a.hasaudio) ? BsMicFill : BsMicMuteFill }),
            React.createElement(Icon, { w: '30px', h: '30px', onClick: () => this.endCall(), _hover: { cursor: 'pointer' }, as: FcEndCall, ml: '30px' }),
            React.createElement(Icon, { w: '30px', h: '30px', _hover: { cursor: 'pointer' }, onClick: () => this.toggleMyVideo(), as: ((_b = rstore.mediastore.mymedia) === null || _b === void 0 ? void 0 : _b.hasvideo) ? FcVideoCall : FcNoVideo, ml: '30px' }),
            !testIsMobile() && devicesavaliab && React.createElement(Icon, { w: '30px', h: '30px', color: true ? 'green' : 'red', _hover: { cursor: 'pointer' }, onClick: () => this.shareScreen(), as: !rstore.mediastore.sharingscreen ? MdScreenShare : MdStopScreenShare, ml: '30px' }),
            !testIsMobile() && React.createElement(Icon, { w: '30px', h: '30px', color: 'red', _hover: { cursor: 'pointer' }, onClick: () => this.fullScreen(), as: GoScreenFull, ml: '30px' }),
            React.createElement(Icon, { w: '30px', h: '30px', color: true ? 'green' : 'red', _hover: { cursor: 'pointer' }, onClick: () => this.switchMediaDevice(), as: FcSwitchCamera, ml: '30px' }));
    }
};
MediaControl.contextType = StoreContext;
MediaControl = __decorate([
    observer
], MediaControl);
export { MediaControl };
